import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import request from '@/utils/request';

// 列表
export function getList(params) {
  return request({
    url: '/package/package-programme/sell-data',
    method: 'get',
    params: params
  });
}

// 销售 方案列表
export function getSaleSchemeList(params) {
  return request({
    url: '/v1/package/package-programme/sell-data',
    method: 'get',
    params: params
  });
}
// 运营 方案列表
export function getOperatorSchemeList(params) {
  return request({
    url: '/package/package-programme/operator-data',
    method: 'get',
    params: params
  });
}

// 销售 方案添加
export function saleSchemeAdd(data) {
  return request({
    url: '/package/package-programme/sell-insert',
    method: 'post',
    data: data
  });
}

// 运营 方案添加
export function operatorSchemeAdd(data) {
  return request({
    url: '/package/package-programme/operator-insert',
    method: 'post',
    data: data
  });
}

// 销售方案删除
export function saleSchemeDel(data) {
  return request({
    url: '/package/package-programme/delete',
    method: 'post',
    data: data
  });
}
// 运营方案删除
export function operateSchemeDel(data) {
  return request({
    url: '/package/package-programme/delete-operate',
    method: 'post',
    data: data
  });
}

// 销售 方案编辑提交
export function saleSchemeUpdate(data) {
  return request({
    url: '/package/package-programme/sell-to-update',
    method: 'post',
    data: data
  });
}

// 运营 方案编辑提交
export function operatorSchemeUpdate(data) {
  return request({
    url: '/package/package-programme/operator-to-update',
    method: 'post',
    data: data
  });
}

// 获取商机信息
export function getOpportunityInfo(params) {
  return request({
    url: '/package/user-opportunity/data',
    method: 'get',
    params: params
  });
}

// 获取企业信息
export function getCompanyInfo() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/package/customer/data',
    method: 'get',
    params: _objectSpread({
      is_delete: '0'
    }, params),
    timeout: 3 * 60 * 1000
  });
}

// 预览 获取过期日期
export function previewScheme(data) {
  return request({
    url: '/package/package-programme/preview-time-refresh',
    method: 'post',
    data: data
  });
}

// 销售 方案复制
export function saleSchemeCopy(data) {
  return request({
    url: '/package/package-programme/sell-copy',
    method: 'post',
    timeout: 10 * 60 * 1000,
    data: data
  });
}

// 运营 方案复制
export function operatorSchemeCopy(data) {
  return request({
    url: '/package/package-programme/operator-copy',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}

// 预览 获取销售人员列表
export function getSellUsers(params) {
  return request({
    url: 'package/package-programme/user-ids',
    method: 'get',
    params: params
  });
}

// 运营 方案发布
export function operatorSchemeRelease(data) {
  return request({
    url: '/package/package-programme/issue',
    method: 'post',
    data: data
  });
}

// 运营 取消方案发布
export function operatorSchemeUnRelease(data) {
  return request({
    url: '/package/package-programme/cancel-issue',
    method: 'post',
    data: data
  });
}
// 销售方案列表参数配置查看
export function salesGetPackageProgrammeConfigInfo(params) {
  return request({
    url: '/package/package-programme/config-info',
    method: 'get',
    params: params
  });
}
// 运营方案列表参数配置查看
export function operateGetPackageProgrammeConfigInfo(params) {
  return request({
    url: '/package/package-programme/config-info-operate',
    method: 'get',
    params: params
  });
}
// 销售保存配置
export function salesUpdatePackageProgrammeConfigInfo(data) {
  return request({
    url: '/package/package-programme/config-update',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 运营保存配置
export function operateUpdatePackageProgrammeConfigInfo(data) {
  return request({
    url: '/package/package-programme/config-update-operate',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}

// 根据方案id获取礼包
export function getSchemeGift(params) {
  return request({
    url: '/package/package-programme/package-share',
    method: 'get',
    params: params
  });
}

// 获取销售人员数据
export function getSalePerson(params) {
  return request({
    url: '/package/package-programme/share-user',
    method: 'get',
    params: params
  });
}

// 分享方案
export function createShareGift(data) {
  return request({
    url: '/package/package-programme/share-sure',
    method: 'post',
    data: data
  });
}

// 获取 参数配置
export function getThemeList(params) {
  return request({
    url: '/mapdepot/map-depot-type/index',
    method: 'get',
    params: params
  });
}

// 图库管理  加载更多图片
export function moreImage(params) {
  return request({
    url: '/mapdepot/map-depot-type/more',
    method: 'get',
    params: params
  });
}

// 方案列表获取默认预览主题图
export function getPreviewDefaultImg(params) {
  return request({
    url: '/mapdepot/map-depot-type/get-one-default',
    method: 'get',
    params: params
  });
}

// 方案更新预览默认图
export function updateDefaultImg(data) {
  return request({
    url: '/package/package-programme/preview-image',
    method: 'post',
    data: data
  });
}

// 获取ppt列表
export function getPptList(params) {
  return request({
    url: '/package/php-office/index',
    method: 'get',
    params: params
  });
}

// 获取下载ppt模板url
export function downPptUrl(data) {
  return request({
    url: '/package/php-office/create-ppt',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}

// 销售更新公司，方案名称
export function salesUpdateVirtualName(params) {
  return request({
    url: '/package/package-programme/virtual-name',
    method: 'get',
    params: params
  });
}
// 运营更新公司，方案名称
export function operateUpdateVirtualName(params) {
  return request({
    url: '/package/package-programme/virtual-name-operate',
    method: 'get',
    params: params
  });
}
// 下载质检报告
export function downPackageProgrammeReports(params) {
  return request({
    url: 'package/package-programme/quality-reports-zip',
    method: 'get',
    params: params
  });
}
// 销售方案excel导出
export function getProgrammeExcel(data) {
  return request({
    url: '/package/package-programme/export',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 公司方案excel导出
export function getProgrammeExcelOperate(data) {
  return request({
    url: '/package/package-programme/export-operate',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 查看方案日志
export function viewGeneralLogList(params) {
  return request({
    url: '/package/general-log/index',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 下载质检报告
export function downChoiceExcel(data) {
  return request({
    url: '/package/package-programme/export-company-programme-goods',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}

// 方案预览更新颜色
export function updateColor(data) {
  return request({
    url: '/package/package-programme/to-update-color',
    method: 'post',
    data: data
  });
}

// 获取ppt内页
export function getInsidePpt(params) {
  return request({
    url: '/mapdepot/map-depot-type/index-img',
    method: 'get',
    params: params
  });
}

// 方案预览生成ppt
export function createPpt(data) {
  return request({
    url: '/package/php-office/create-ppt-colorful',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}

// 缤纷内页下载记录
export function getPptRecord(params) {
  return request({
    url: '/package/php-office/download-index',
    method: 'get',
    params: params
  });
}
// 销售缤纷内页下载记录
export function getSalePptRecord(params) {
  return request({
    url: '/package/php-office/download-index-sale',
    method: 'get',
    params: params
  });
}
// 运营缤纷内页下载记录
export function getOperatePptRecord(params) {
  return request({
    url: '/package/php-office/download-index-operate',
    method: 'get',
    params: params
  });
}

// 获取礼包折扣图标
export function getPptSparkIcon(params) {
  return request({
    url: '/mapdepot/map-depot-type/index-img',
    method: 'get',
    params: params
  });
}

// 公司方案预览生成ppt火花
export function createPptSparkOperate(data) {
  return request({
    url: '/package/php-office/create-ppt-spark-operate',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}

// 销售方案预览生成ppt火花
export function createPptSparkSale(data) {
  return request({
    url: '/package/php-office/create-ppt-spark',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}

// 方案下载完善效果图
export function getDownSchemeImage(params) {
  return request({
    url: '/package/package-programme/gift-bag-result-zip-goods-image-batch',
    method: 'get',
    params: params
  });
}

// 获取渠道列表
export function getChannelList(data) {
  return request({
    url: '/orders/channel/list',
    method: 'post',
    data: data
  });
}
// 保存开屏动画
export function saveScreenAnimation(data) {
  return request({
    url: '/package/programme-extend/save-extend',
    method: 'post',
    data: data
  });
}
// 获取开屏动画的数据
export function getScreenAnimation(params) {
  return request({
    url: '/package/programme-extend/update',
    method: 'get',
    params: params
  });
}
// 公司方案获取渠道列表
export function getOperateChannel(params) {
  return request({
    url: '/orders/channel/list-programme',
    method: 'get',
    params: params
  });
}
// 同步公司方案
export function syncProgramme(params) {
  return request({
    url: '/package/package-programme/sync-programme-channel',
    method: 'get',
    params: params
  });
}
// 设置精选
export function setPickPackage(data) {
  return request({
    url: '/package/package/set-pick-package',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 精选礼包列表
export function getPickPackageList(params) {
  return request({
    url: '/package/package/pick-package-list',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 删除精选礼包
export function delPickPackage(params) {
  return request({
    url: '/package/package/pick-package-delete',
    method: 'get',
    params: params
  });
}

//分类接口数据
export function getSonData(params) {
  return request({
    url: '/mapdepot/map-depot-type/son-type-data',
    method: 'get',
    params: params
  });
}

// 图库上级分类
export function getMapDepotType(params) {
  return request({
    url: '/mapdepot/map-depot-type/get-type',
    method: 'get',
    params: params
  });
}
//获取上午支持数据
export function getBusinessUser(params) {
  return request({
    url: '/package/package-programme/business-user',
    method: 'get',
    params: params
  });
}
//修改精选礼包备注
export function pickPackageUpdate(params) {
  return request({
    url: '/package/package/pick-package-update',
    method: 'get',
    params: params
  });
}
// 设置精选
export function exportSalesProgramme(data) {
  return request({
    url: '/package/package-programme/export-sale-programme',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 获取应用场景
export function getPackUsageList(params) {
  return request({
    url: '/package/package-usage/data',
    method: 'get',
    params: params
  });
}
// 获取礼包分类
export function getPackageCat(params) {
  return request({
    url: '/package/package/package-cat-goods-cat-search',
    method: 'get',
    params: params
  });
}
// 获取明星销售列表
export function getStarSalesList(params) {
  return request({
    url: '/package/celebrity-sales/index',
    method: 'get',
    params: params
  });
}
// 获取销售列表
export function getSalesList(params) {
  return request({
    url: '/package/celebrity-sales/sales-list',
    method: 'get',
    params: params
  });
}
// 添加明星销售
export function addStarSale(data) {
  return request({
    url: '/package/celebrity-sales/create',
    method: 'post',
    data: data
  });
}
// 删除明星销售
export function delStarSale(params) {
  return request({
    url: '/package/celebrity-sales/delete',
    method: 'get',
    params: params
  });
}
// 获取销售方案数据条数
export function getSaleProgramCount(data) {
  return request({
    url: '/package/package-programme/export-sale-programme-count',
    method: 'post',
    data: data
  });
}
// 后台预览获取数据
export function getPackageDecoration(params) {
  return request({
    url: '/package/package-programme/package-decoration',
    method: 'get',
    params: params
  });
}
// 后台预览获取商品数据  销售
export function getPackageDecorationList(params) {
  return request({
    url: '/package/package-programme/package-decoration-index',
    method: 'get',
    params: params
  });
}
// 后台预览获取商品数据  公司
export function getPackageDecorationListOperate(params) {
  return request({
    url: '/package/package-programme/package-decoration-index-operate',
    method: 'get',
    params: params
  });
}
// 礼包列表装修 - 获取可用组件
export function getPackageListDecorationWidgets(params) {
  return request({
    url: '/decoration/decoration-package-programme/widget',
    method: 'get',
    params: params
  });
}
// 礼包列表装修 - 获取礼包方案/礼包数据
export function getPackageListDecorationCustomerPackage(params) {
  return request({
    url: '/decoration/decoration-package-programme/get-customer-package',
    method: 'get',
    params: params
  });
}
// 礼包列表装修 - 获取页面数据
export function getPackageListDecorationHome(params) {
  return request({
    url: '/decoration/decoration-package-programme/home',
    method: 'get',
    params: params
  });
}
// 礼包列表装修 - 保存单个组件
export function updatePackageListDecorationWidget(data) {
  return request({
    url: '/decoration/decoration-package-programme/update',
    method: 'post',
    data: data
  });
}
// 礼包列表装修 - 发布
export function savePackageListDecoration(data) {
  return request({
    url: '/decoration/decoration-package-programme/save',
    method: 'post',
    data: data
  });
}
// 礼包列表装修 - 获取菜单列表（普通方案传customer_id和channel_id，促销方案传channel_id）
export function getPackageListDecorationCategory(params) {
  return request({
    url: '/decoration/decoration-package-programme/category',
    method: 'get',
    params: params
  });
}
// 后台预览获取预览配置
export function getPackageProgramme(params) {
  return request({
    url: '/package/package-programme/update',
    method: 'get',
    params: params
  });
}
// 保存销售右配置数据
export function setPackageProgramme(data) {
  return request({
    url: '/package/package-programme/package-decoration-set',
    method: 'post',
    data: data
  });
}
// 保存销售右配置数据
export function setPackageProgrammeOperate(data) {
  return request({
    url: '/package/package-programme/package-decoration-set-operate',
    method: 'post',
    data: data
  });
}
// 获取销售方案数据
export function getPackageSaleData(params) {
  return request({
    url: '/package/package-programme/pick-package-sell-data',
    method: 'get',
    params: params
  });
}
// 复制精选礼包到方案
export function addSelectPack(data) {
  return request({
    url: '/package/package/copy-package-pick',
    method: 'post',
    data: data
  });
}
// 方案装修 选择图片
export function getDepotPicList(params) {
  return request({
    url: '/mapdepot/map-depot-type/index-img',
    method: 'get',
    params: params
  });
}
// 方案装修图 片tab
export function getTypeDepotPicList(params) {
  return request({
    url: '/mapdepot/map-depot-type/son-type-data',
    method: 'get',
    params: params
  });
}
// 精选礼包数据干预
export function dataInterfere(data) {
  return request({
    url: '/package/package/pick-package-data-intervention',
    method: 'post',
    data: data
  });
}
// 获取配置信息
export function getDataConfig(params) {
  return request({
    url: '/package/package-config/channel-data',
    method: 'get',
    params: params
  });
}
// 销售计算返点
export function packageSaleCalculation(params) {
  return request({
    url: '/package/package/pick-package-calculation-rate',
    method: 'get',
    params: params
  });
}
// 销售获取礼包左侧商品列表
export function getSalePackageGoods(params) {
  return request({
    url: '/package/goods/pick-package-goods',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
export function updateSalesPackage(data) {
  return request({
    url: '/package/package/pick-package-to-update',
    method: 'post',
    data: data
  });
}
// 精选礼包方案应用明细
export function packagePickProgrammeDetail(params) {
  return request({
    url: '/package/package/pick-detail-programme',
    method: 'get',
    params: params
  });
}
// 精选礼包礼包应用明细
export function packagePickDetail(params) {
  return request({
    url: '/package/package/pick-detail-package',
    method: 'get',
    params: params
  });
}
export function savePickGiftConfig(data) {
  return request({
    url: '/package/package-config/exchange-num-quantity-to-update',
    method: 'post',
    data: data
  });
}
// 精选礼包礼包应用明细
export function getPickGiftConfigInfo(params) {
  return request({
    url: '/package/package-config/exchange-num-quantity-info',
    method: 'get',
    params: params
  });
}
// 公司方案批量排序
export function addImpressionDrawing(data) {
  return request({
    url: 'package/package-extend/add-impression-drawing',
    method: 'post',
    data: data
  });
}
// 公司方案批量排序
export function addSaleImpressionDrawing(data) {
  return request({
    url: 'package/package-extend/add-impression-drawing-sale',
    method: 'post',
    data: data
  });
}
// 公司方案批量排序
export function addPickImpressionDrawing(data) {
  return request({
    url: 'package/package-extend/add-impression-drawing-pick',
    method: 'post',
    data: data
  });
}
// 添加商务支持
export function addBusinessSupport(data) {
  return request({
    url: '/package/programme-purchase-quotation/save-create',
    method: 'post',
    data: data
  });
}

// 商务支持列表
export function getBusinessSupport(params) {
  return request({
    url: '/package/programme-purchase-quotation/index',
    method: 'get',
    params: params
  });
}
// 商务支持列表
export function getBusinessSupportInfo(params) {
  return request({
    url: '/package/programme-purchase-quotation/update',
    method: 'get',
    params: params
  });
}
// 申请商务支持
export function editBusinessSupport(data) {
  return request({
    url: '/package/programme-purchase-quotation/save-update',
    method: 'post',
    data: data
  });
}
// 参与报价
export function participateQuotation(params) {
  return request({
    url: '/package/programme-purchase-quotation/participate-quotation',
    method: 'get',
    params: params
  });
}
// 截止报价
export function endParticipateQuotation(params) {
  return request({
    url: '/package/programme-purchase-quotation/end-quotation',
    method: 'get',
    params: params
  });
}
// 修改商务支持负责人
export function editBusinessPuotationUser(data) {
  return request({
    url: '/package/programme-purchase-quotation/edit-business',
    method: 'post',
    data: data
  });
}
// 获取已配置商务人员列表
export function getBusinessUserList(params) {
  return request({
    url: '/package/programme-purchase-quotation-business/index',
    method: 'get',
    params: params
  });
}

// 添加商务支持负责人
export function addBusinessUser(data) {
  return request({
    url: '/package/programme-purchase-quotation-business/create',
    method: 'post',
    data: data
  });
}
// 删除商务支持负责人
export function delBusinessUser(params) {
  return request({
    url: '/package/programme-purchase-quotation-business/delete',
    method: 'get',
    params: params
  });
}
// 获取所有商务人员列表
export function getAllBusinessUserList(params) {
  return request({
    url: '/package/package-programme/user-ids',
    method: 'get',
    params: params
  });
}
// 商务信息更新日志
export function getBusinessUpdateLog(params) {
  return request({
    url: '/package/programme-purchase-quotation-log/index',
    method: 'get',
    params: params
  });
}
// 校验是否参加过该方案商务支持
export function checkAddBusinessUser(params) {
  return request({
    url: '/package/programme-purchase-quotation/check-add',
    method: 'get',
    params: params
  });
}
// 校验是否参加过该方案商务支持
export function recoverQuotation(params) {
  return request({
    url: '/package/programme-purchase-quotation/recover-quotation',
    method: 'get',
    params: params
  });
}
// 意向单获取临时商品
export function getTempGoodsList(params) {
  return request({
    url: '/package/programme-purchase-quotation/get-temporary-goods',
    method: 'get',
    params: params
  });
}
// 意向单获取报价信息
export function getQuotationList(params) {
  return request({
    url: '/package/programme-purchase-quotation/get-temporary-goods-offer',
    method: 'get',
    params: params
  });
}
// 获取意向单 供应商保护
export function getSupplierProtect(params) {
  return request({
    url: '/package/programme-purchase-quotation/business-sup-index',
    method: 'get',
    params: params
  });
}
export function getSupplierLevelData(params) {
  return request({
    url: '/package/package/get-supplier-and-level-data',
    method: 'get',
    params: params
  });
}
// 修改商务支持负责人
export function editBusinessSupplier(data) {
  return request({
    url: '/package/programme-purchase-quotation/edit-business-supplier',
    method: 'post',
    data: data
  });
}
// 修改商务支持负责人
export function editSelfBusinessSupplier(data) {
  return request({
    url: '/package/programme-purchase-quotation/edit-business-supplier-person',
    method: 'post',
    data: data
  });
}
// 获取按金额分类列表
export function getMoneyConfigList(params) {
  return request({
    url: '/package/package-price-customize/index',
    method: 'get',
    params: params
  });
}
// 增加金额分类
export function addShowMoneyConfig(data) {
  return request({
    url: '/package/package-price-customize/create',
    method: 'post',
    data: data
  });
}
// 编辑金额分类列表
export function editMoneyConfig(data) {
  return request({
    url: '/package/package-price-customize/to-update',
    method: 'post',
    data: data
  });
}
// 删除金额分类
export function delMoneyConfig(params) {
  return request({
    url: '/package/package-price-customize/delete',
    method: 'get',
    params: params
  });
}
// 获取按金额分类列表
export function getPriceTabs(params) {
  return request({
    url: '/package/package-programme/package-decoration-index-price',
    method: 'get',
    params: params
  });
}
// 添加供应商校验有额外的供应商保护
export function checkOfferAddSupplier(params) {
  return request({
    url: '/package/package/check-offer-add-supplier',
    method: 'get',
    params: params
  });
}
// 临时商品库添加临时商品
export function addTempGoods(data) {
  return request({
    url: '/package/temporary-goods/add',
    method: 'post',
    data: data
  });
}
// 临时商品库编辑临时商品
export function subEditTempGoods(data) {
  return request({
    url: '/package/temporary-goods/edit',
    method: 'post',
    data: data
  });
}
// 添加临时商品获取品牌数据
export function getOptimalSupplie(params) {
  return request({
    url: '/package/temporary-goods/get-brand-optimal-supplier',
    method: 'get',
    params: params
  });
}
// 获取临时商品数据
export function getTemporaryList(params) {
  return request({
    url: '/package/temporary-goods/list',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 删除临时商品询价数据
export function delOfferItem(params) {
  return request({
    url: '/package/temporary-goods/del-offer',
    method: 'get',
    params: params
  });
}
// 临时商品库编辑供询价
export function editOfferData(data) {
  return request({
    url: '/package/temporary-goods/edit-offer',
    method: 'post',
    data: data
  });
}
// 删除临时商品数据
export function delTempGoods(params) {
  return request({
    url: '/package/temporary-goods/del',
    method: 'get',
    params: params
  });
}
// 获取供应商询价
export function getSupplierPurchase(params) {
  return request({
    url: '/package/temporary-goods/offer-data-by-sup-and-brand',
    method: 'get',
    params: params
  });
}
// 临时商品完成询价
export function tempGoodsFinishInquiry(params) {
  return request({
    url: '/package/temporary-goods/finish-inquiry',
    method: 'get',
    params: params
  });
}
// 临时商品重新询价
export function tempGoodsReInquiry(params) {
  return request({
    url: '/package/temporary-goods/re-inquiry',
    method: 'get',
    params: params
  });
}
// 替换商品id获取商品信息
export function getGoodsIdInfo(params) {
  return request({
    url: '/package/package/check-goods-status',
    method: 'get',
    params: params
  });
}
// 礼包商品效果图下载
export function downGiftPackGoodsImg(params) {
  return request({
    url: '/package/package-programme/gift-image-zip-goods-pick-package',
    method: 'get',
    params: params
  });
}
// 替换临时商品为专属集采商品
export function subReplaceTempGoods(data) {
  return request({
    url: '/package/temporary-goods/replace-goods',
    method: 'post',
    data: data
  });
}
// 销售发起库存获取详情
export function getWorkOrderInfoUpdate(params) {
  return request({
    url: '/package/programme-inventory-work-order/get-info',
    method: 'get',
    params: params
  });
}
// 创建库存工单
export function saveCreateSale(data) {
  return request({
    url: '/package/programme-inventory-work-order/save-create-sale',
    method: 'post',
    data: data
  });
}
// 运营创建库存工单
export function saveCreateOperate(data) {
  return request({
    url: '/package/programme-inventory-work-order/save-create-operate',
    method: 'post',
    data: data
  });
}
// 获取物流公司
export function getExpressData(params) {
  return request({
    url: '/package/goods/express-data',
    method: 'get',
    params: params
  });
}
export function getCustomerCompanyName(params) {
  return request({
    url: '/orders/customer/get-company-name',
    method: 'get',
    params: params
  });
}
// 个性化规则 保存礼包风格
export function savePersonalizedData(data) {
  return request({
    url: '/package/package-personalized-style/save-data',
    method: 'post',
    data: data
  });
}
// 获取业务联系人
export function getSubContactsList(params) {
  return request({
    url: '/package/temporary-goods/sup-contacts-by-sup-id',
    method: 'get',
    params: params
  });
}
// 获取其他询价数量
export function getOfferInquiryCount(params) {
  return request({
    url: '/package/temporary-goods/get-else-offer-count',
    method: 'get',
    params: params
  });
}
// 获取税率列表
export function getTaxRate(params) {
  return request({
    url: '/package/temporary-goods/get-tax-points',
    method: 'get',
    params: params
  });
}
// 礼包系统查看 公司名称
export function getNewCustomerCompanyName(params) {
  return request({
    url: '/package/package-programme/get-company-name-info',
    method: 'get',
    params: params
  });
}
// 礼包系统查看 方案名称
export function getNewCustomerProgrammeName(params) {
  return request({
    url: '/package/package-programme/get-name-info',
    method: 'get',
    params: params
  });
}
export function getSaleUserList(data) {
  return request({
    url: '/user/user-customer/user-list',
    method: 'post',
    data: data
  });
}
// 获取促销方案关联菜单
export function getCorrelationMenu(params) {
  return request({
    url: '/package/package-programme/get-correlation-category-list',
    method: 'get',
    params: params
  });
}
export function programmeDataOverview(params) {
  return request({
    url: '/count/package/programme-data-overview',
    method: 'get',
    params: params
  });
}
export function programmeDataOverviewOperate(params) {
  return request({
    url: '/count/package/programme-data-overview-operate',
    method: 'get',
    params: params
  });
}
export function getChannelPreviewUrl(params) {
  return request({
    url: '/package/package-programme/get-preview-url',
    method: 'get',
    params: params
  });
}
// 下载销售方案礼包效果图
export function downImpressionDrawingSale(params) {
  return request({
    url: '/package/package-programme/down-impression-drawing-sale',
    method: 'get',
    params: params
  });
}
// 下载公司方案礼包效果图
export function downImpressionDrawing(params) {
  return request({
    url: '/package/package-programme/down-impression-drawing',
    method: 'get',
    params: params
  });
}
// 导出pdf记录日志
export function downPdfRecordLog(params) {
  return request({
    url: '/package/package-programme/export-pdf',
    method: 'get',
    params: params
  });
}
// 获取缺货礼包
export function getStockoutPackage(params, entryType) {
  var url = {
    1: '/package/package-programme/handle-out-of-stock-ordered',
    // 已下单
    0: '/package/package-programme/handle-out-of-stock-not-ordered' // 未下单
  }[entryType];
  return request({
    url: url,
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 获取商务满意度人员信息
export function getSatisfaction(params) {
  return request({
    url: '/package/programme-purchase-quotation/satisfaction',
    method: 'get',
    params: params
  });
}
// 获取商务满意度人员信息二维码
export function getSatisfactionQrcode(params) {
  return request({
    url: '/package/programme-purchase-quotation/satisfaction-qr',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 库存校验 
export function getProgrammeInventoryCheckErrorGoods(params) {
  return request({
    url: '/package/programme-inventory-work-order/error-goods',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 获取京东或顺丰运费
export function getDefaultConfig(params) {
  return request({
    url: '/package/package-programme/get-default-config',
    method: 'get',
    params: params
  });
}
// 添加礼包评选人员
export function saveEvaluationUser(data) {
  return request({
    url: '/package/package-programme-evaluation-user/save',
    method: 'post',
    data: data
  });
}

// 礼包评选人员全部列表
export function getEvaluationUserList(params) {
  return request({
    url: '/package/package-programme-evaluation-user/index',
    method: 'get',
    params: params
  });
}
// 礼包评选人员列表
export function getEvaluationUserPersonalList(params) {
  return request({
    url: '/package/package-programme-evaluation-user/index-personal',
    method: 'get',
    params: params
  });
}

// 设置评选人员有效/无效状态
export function setEvaluationUserValid(data) {
  return request({
    url: '/package/package-programme-evaluation-user/set-valid',
    method: 'post',
    data: data
  });
}
// 礼包评选结果列表
export function getEvaluationResultList(params) {
  return request({
    url: '/package/package-programme-evaluation-result/index',
    method: 'get',
    params: params
  });
}
// 礼包评选结果获取方案列表
export function getEvaluationProgramme(params) {
  return request({
    url: '/package/package-programme-evaluation-user/get-programme',
    method: 'get',
    params: params
  });
}